var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.base.org.logo !== '')?_c('v-img',{key:_vm.$store.state.base.org.logo,staticClass:"orgLogo",attrs:{"src":_vm.orgLogo}}):_c('span',{staticClass:"orgName"},[_vm._v(_vm._s(_vm.$store.state.base.org.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }